/* eslint-disable react/prop-types */
import React from "react";
import {connect} from "react-redux";
import {Button, Table} from "react-bootstrap";

import "../css/Nexts.css";
import {NextTaskForm} from "./NextTaskForm";
import {UI_SORT, UI_TOGGLE} from "../actions/ui";
import {SWITCH_TOGGLE} from "../actions/switch_toggle";
import {currentToggleValue, NEXT_LIST_KEY, NEXTS_NEED_COMMENT_FILTER_KEY} from "../utils/toggle";
import {getSortedFilteredNexts} from "../selectors/nexts";



// component
class InternalAssign extends React.Component {

  sortIconClass(colKey) {
    if (this.props.currentSortKey !== colKey) return 'fa-solid fa-sort sort-icon';
    return this.props.currentSortDir === 'desc'
      ? 'fa-solid fa-sort-down sort-icon'
      : 'fa-solid fa-sort-up sort-icon';
  }

  sortThClass(colKey) {
    return 'sortable ' + (this.props.currentSortKey === colKey ? 'sort-current' : '');
  }

  render() {
    return (
      <div className="Assign row">
        <div className="col-md-12">
          <h4 >
            Préparateurs et types de tâches
            {this.props.onToggle ? <button className="btn btn btn-default btn-xs float-right" onClick={(e) => this.props.onToggle()}  >{this.props.showAll ? "Cacher" : "Afficher"}</button> : null}
            <button
              className={"btn btn-xs float-right " + (this.props.needCommentFilter ? "btn-danger" : "btn-default")}
              style={{ marginRight: "6px" }}
              title="Filtrer pour ne voir que les préparateurs avec qui faire le point"
              onClick={() => this.props.toggleNeedCommentFilter()}
            >
              Faire le point avec
            </button>
          </h4>
          {this.props.showAll || !this.props.onToggle ? <div>
            <Table bordered size="sm" hover striped>
              <thead>
                <tr>
                  <th className={this.sortThClass('name')} onClick={() => this.props.persistantSort('name')}>
                    Nom <i className={this.sortIconClass('name')} />
                  </th>
                  <th>Droits</th>
                  <th className={this.sortThClass('lastStartedTask')} onClick={() => this.props.persistantSort('lastStartedTask')}>
                    Dernière tâche  / tâche en cours <i className={this.sortIconClass('lastStartedTask')} />
                  </th>
                  <th className={this.sortThClass('duration')} onClick={() => this.props.persistantSort('duration')}>
                    Durée <i className={this.sortIconClass('duration')} />
                  </th>
                  <th className={this.sortThClass('iph_7d')} onClick={() => this.props.persistantSort('iph_7d')}>
                    IPH 7j <i className={this.sortIconClass('iph_7d')} />
                  </th>
                  <th className={this.sortThClass('time_packing_7d')} onClick={() => this.props.persistantSort('time_packing_7d')}>
                    Temps prep 7j <i className={this.sortIconClass('time_packing_7d')} />
                  </th>
                  <th className={this.sortThClass('time_stockpilling_7d')} onClick={() => this.props.persistantSort('time_stockpilling_7d')}>
                    Temps MeS 7j <i className={this.sortIconClass('time_stockpilling_7d')} />
                  </th>
                  <th>Tâche suivante</th>
                </tr>
              </thead>
              <tbody>
                {this.props.nexts.map(p => <NextTaskForm nextTask={p} key={p.id} iph_by_packer={this.props.iph_by_packer} cph_by_packer={this.props.cph_by_packer} tad_by_packer={this.props.tad_by_packer} tap_by_packer={this.props.tap_by_packer} timespent_by_packer={this.props.timespent_by_packer} iphreappro_by_packer={this.props.iphreappro_by_packer} />)}
                <tr>
                  <td colSpan={8} style={{textAlign: "center"}}>
                    <Button variant="default" size="xs"  onClick={() => this.props.showMoreToggle()} >Afficher / Cacher les "hors session"</Button>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div> : null}
        </div>
      </div>
    );
  }
}

const SHOW_MORE_KEY  = 'next_show_more';

// link
export const Nexts = connect(
  (state) => {
    let props = {
      nexts: getSortedFilteredNexts(state),
      iph_by_packer: {},
      // cph_by_packer: {},
      tad_by_packer: {},
      tap_by_packer: {},
      timespent_by_packer: {},
      iphreappro_by_packer: {}
    };
    if (state.m.packerstatiph && typeof(state.m.packerstatiph.iph_by_packer) !== 'undefined') {
      props.iph_by_packer = state.m.packerstatiph.iph_by_packer;
    }
    // if (state.m.packerstatstockpilling && typeof(state.m.packerstatstockpilling.cph_by_packer) !== 'undefined') {
    //   props.cph_by_packer = state.m.packerstatstockpilling.cph_by_packer;
    // }
    if (state.m.packerstatsordermoving && typeof(state.m.packerstatsordermoving.by_packer) !== 'undefined') {
      props.tad_by_packer = state.m.packerstatsordermoving.by_packer;
    }
    if (state.m.packerstatsbeforepicking && typeof(state.m.packerstatsbeforepicking.by_packer) !== 'undefined') {
      props.tap_by_packer = state.m.packerstatsbeforepicking.by_packer;
    }
    if (state.m.packerstattimespent && typeof(state.m.packerstattimespent.by_packer) !== 'undefined') {
      props.timespent_by_packer = state.m.packerstattimespent.by_packer;
    }
    if (state.m.packerstatiphreappro && typeof(state.m.packerstatiphreappro.by_packer) !== 'undefined') {
      props.iphreappro_by_packer = state.m.packerstatiphreappro.by_packer;
    }

    const rawSort = state.ui.sort['nexts'];
    const currentSort = !rawSort
      ? {key: 'name', dir: 'asc'}
      : (typeof rawSort === 'string' ? {key: rawSort, dir: 'asc'} : rawSort);

    props.showAll = currentToggleValue(state.toggle, NEXT_LIST_KEY);
    props.needCommentFilter = currentToggleValue(state.toggle, NEXTS_NEED_COMMENT_FILTER_KEY);
    props.currentSortKey = currentSort.key;
    props.currentSortDir = currentSort.dir;
    return props;
  },
  (dispatch) => {
    return {
      "persistantSort": (colKey) => (dispatch({type: UI_SORT, colKey: colKey, colGroup: 'nexts'})),
      "showMoreToggle": () => (dispatch({type: UI_TOGGLE, key: SHOW_MORE_KEY})),
      "onToggle":       () => dispatch({type: SWITCH_TOGGLE, key: NEXT_LIST_KEY}),
      "toggleNeedCommentFilter": () => dispatch({type: SWITCH_TOGGLE, key: NEXTS_NEED_COMMENT_FILTER_KEY}),
    };
  }
)(InternalAssign);
